module.exports = __webpack_public_path__ + "static/media/mobile-lostasylum-cover.07c5d73b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/mobile-lostasylum-cover.jpg
// module id = 567
// module chunks = 0